import { cn } from "@lib/cn";
import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react";

export const SessionNavigation = ({
  onPrevSession,
  onNextSession,
  hasPrevSession,
  hasNextSession,
  sessionNumber,
  singleSessionVisitor,
}: {
  onPrevSession: () => void;
  onNextSession: () => void;
  hasPrevSession: boolean;
  hasNextSession: boolean;
  sessionNumber: number;
  singleSessionVisitor: boolean;
}) => {
  const showNavigation =
    !singleSessionVisitor && (hasPrevSession || hasNextSession);
  if (!showNavigation) return null;
  return (
    <div className="tw-flex tw-items-center tw-justify-between">
      <button
        onClick={onPrevSession}
        type="button"
        className={cn(
          "tw-flex tw-items-center tw-justify-center tw-shadow-2xs tw-px-4 tw-py-2 -lg:tw-text-base tw-rounded-lg tw-outline-1 tw-outline tw-outline-blue/5 tw-bg-white hover:tw-bg-blue-50 tw-transition-colors",
          {
            "tw-opacity-0 tw-invisible": !hasPrevSession,
          },
        )}
      >
        <IconArrowLeft />
        <span className="tw-font-sans tw-font-normal tw-text-base tw-text-blue tw-ml-2">
          Session #{(sessionNumber || 1) - 1}
        </span>
      </button>
      <button
        onClick={onNextSession}
        disabled={!hasNextSession}
        type="button"
        className={cn(
          "tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-2 tw-shadow-2xs -lg:tw-text-base tw-rounded-lg tw-outline-1 tw-outline tw-outline-blue/5 tw-bg-white hover:tw-bg-blue-50 tw-transition-colors",
          {
            "tw-opacity-0 tw-invisible": !hasNextSession,
          },
        )}
      >
        <span className="tw-font-sans tw-font-normal tw-text-base tw-text-blue tw-mr-2">
          Session #{(sessionNumber || 1) + 1}
        </span>
        <IconArrowRight />
      </button>
    </div>
  );
};
